/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:11
 * @LastEditTime: 2023-08-31 18:17:07
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\form\field.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Component } from "react";
import { Input, Tooltip } from "@platform/base";
import { match } from '../../libs/utils';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

/**
 * 左侧的属性面板
 */
class Field extends Component {
    constructor(props) {
        super(props);
    }

    onSearch = (value, e) => {
        const { store, code } = this.props;
        const fieldStore = store.getStore(['cache', code, 'field']) || {};
        const { data = [] } = fieldStore;

        const nextData = data.map(item => {
            const { label } = item;
            // 是否是过滤的
            item.filtered = match(label, value);
            return item;
        });

        store.setStore(['cache', code, 'field', 'value'], value, false);
        store.setStore(['cache', code, 'field', 'data'], nextData, true);
        // TODO search
        // scrollIntoView 聚焦到首项
    }

    // 添加信息组
    onInfoGroupToView = (currentItem = {}, index) => {
        const { attrcode, groupInfoId, groupFirstItem } = currentItem;

        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const viewData = store.getStore(['cache', code, 'view', 'data']) || [];
        const fieldData = store.getStore(['cache', code, 'field', 'data']) || [];

        const currentGroup = groupItems[groupInfoId];

        if (currentGroup) {

            // 旧的关联项
            const { direction, itemcode, items } = currentGroup;

            const currentGroupLen = items?.length;

            // 左边移除信息组
            const currentGroupItems = fieldData.splice(index, currentGroupLen);
            // 检查左边还有没有关联字段的信息组，没有的话将虚拟关联想移除
            const hasFieldGroup = fieldData.find(item => item.groupRelationCode === itemcode);
            if (!hasFieldGroup) {
                let spliceIndex = -1;
                fieldData.find((item, index) => {
                    if (item.attrcode === itemcode && item.virtually) {
                        spliceIndex = index;
                    }
                });
                spliceIndex !== -1 && fieldData.splice(spliceIndex, 1);
            }

            // 检查右边有没有对应关联元素
            const hasViewGroup = viewData.find(item => item.attrcode === itemcode);
            // 如果有把数据插入到右边
            if (hasViewGroup) {
                currentGroup.visible = true;
                let spliceIndex = -1;
                viewData.find((item, index) => {
                    if (item.attrcode === itemcode) {
                        spliceIndex = index;
                    }
                });

                if (spliceIndex !== -1) {
                    spliceIndex = currentGroup.direction === 'before' ? spliceIndex : spliceIndex + 1;
                    viewData.splice(spliceIndex, 0, ...currentGroupItems);
                }
            } else {
                // 否则放到最后一个元素上
                // 右边添加信息组
                const viewLen = viewData.length;
                const viewLast = viewData[viewLen - 1];
                // 关联到最后一个字段上
                currentGroup.itemcode = viewLast.attrcode;
                currentGroup.direction = 'after';
                currentGroup.visible = true;
                currentGroupItems.forEach(item => {
                    item.groupRelationCode = viewLast.attrcode;
                });
                viewData.splice(viewData.length, 0, ...currentGroupItems);
            }

            store.setStore(['cache', code, 'view', 'data'], viewData, false);
            store.setStore(['cache', code, 'field', 'data'], fieldData, false);
            store.setStore(['cache', code, 'groupItems'], groupItems);
        } else {
            // console.warn('操作异常');
        }
    }

    render() {

        const { store, code } = this.props;
        const langJson = store.getStore('langJson');
        const fieldStore = store.getStore(['cache', code, 'field']) || {};
        const { value, data = [] } = fieldStore;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        // 用于计数
        let count = 0;

        return <div
            className="field-wrapper"
            fieldid={getSysFieldid('left_area')}
        >
            <div className="field-search">
                <span className="field-search-label">{langJson['field-list-title'] || '待添加'}</span>
                <Input
                    className="field-search-input"
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                />
            </div>
            <ul className="field-list">
                {data.map((item, index) => {

                    const { attrcode, groupInfoId, groupFirstItem, virtually } = item;

                    // 信息组关联的虚拟元素 // 也可以禁用关联元素
                    // if (virtually) {
                    //     return null;
                    // }

                    // 开始分组渲染
                    if (groupInfoId && groupFirstItem) {
                        const { items: itemCodes, name, langname = '', icontype } = groupItems[groupInfoId] || {};
                        count = count === 0 ? 1 : 0;

                        return <li key={`${attrcode}_content`} className={`field-item field-info-group-wrapper count-${count}`}>
                            <div className="field-info-group-title">
                                <div className={`field-info-group-icon`}> <i className="icon iconfont icon-gengduo1"></i></div>
                                <span className="field-info-group-label" title={langname || name}>{langname || name}</span>
                                {!uncontrolledVisible && <span className="field-icon" onClick={this.onInfoGroupToView.bind(this, item, index)}>
                                    <Tooltip
                                        placement="top"
                                        overlay={langJson['action-icon-add']}
                                        delayHide={1}
                                        delayShow={1000}
                                    >
                                        <i className={getIconClass('ncc-sq', 'close')} />
                                    </Tooltip>
                                </span>}
                            </div>
                            <div className="field-info-group-items">
                                {itemCodes.map((attrcode, groupIndex) => {
                                    const itemIndex = index + groupIndex;
                                    const { label } = data[itemIndex] || {};
                                    return <div className="field-info-group-item" key={itemIndex} title={label}>{label}</div>;
                                })}
                            </div>
                        </li>;
                    }

                    // 跳过中间项
                    if (groupInfoId && !groupFirstItem) {
                        return null;
                    }

                    return <ListItem key={attrcode} areaCode={code} store={store} {...item} />;
                })}
            </ul>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 左侧点击选中
    onTransferToView = e => {
        const { store, areaCode, attrcode } = this.props;
        const groupItems = store.getStore(['cache', areaCode, 'groupItems']) || {};
        let nextViewSourceItem = [];
        {
            // 左边移除一个
            const fieldStore = store.getStore(['cache', areaCode, 'field']) || {};
            const { value, data = [] } = fieldStore;

            // 检查左边还有没有关联字段的信息组，有的话需要将信息组一并移动
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode, groupInfoId, groupRelationCode } = item;

                // 关联当前字段的信息组元素
                if (groupRelationCode === attrcode) {
                    const currentGroup = groupItems[groupInfoId];
                    // 信息组显示
                    currentGroup.visible = true;
                    nextViewSourceItem.push(item);
                    return false;
                }

                if (currentCode === attrcode) {
                    // 显示
                    item.visible = true;
                    nextViewSourceItem.push(item);
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['cache', areaCode, 'field', 'data'], nextData, false);
        }
        {
            // 右边添加一个
            const viewStore = store.getStore(['cache', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;
            // 显示
            let nextData = nextViewSourceItem.length ? [...data, ...nextViewSourceItem] : data;

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });
            store.setStore(['cache', areaCode, 'view', 'data'], nextData, true);
        }
    };

    // 点击高亮显示
    onHighlight = e => {
        // 左侧点击高亮，移动到右侧，并且高亮
        const { store, areaCode, attrcode } = this.props;
        let nextViewSourceItem = null;
        {
            // 左边移除一个
            const fieldStore = store.getStore(['cache', areaCode, 'field']) || {};
            const { value, data = [] } = fieldStore;
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode } = item;
                if (currentCode === attrcode) {
                    // 记录数据
                    nextViewSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['cache', areaCode, 'field', 'data'], nextData, false);
        }
        {
            // 右边添加一个
            const viewStore = store.getStore(['cache', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;

            let nextData = data;
            if (nextViewSourceItem) {
                let viewLockedItems = [];
                let viewUnLockedItems = [];
                data.forEach(item => {
                    if (item.islock) {
                        viewLockedItems.push(item);
                    } else {
                        viewUnLockedItems.push(item);
                    }
                });
                nextData = [...viewLockedItems, ...viewUnLockedItems, { ...nextViewSourceItem, ishighlight: true, visible: true }];
            }

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });

            store.setStore(['cache', areaCode, 'view', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            // 是否展示了
            showItem,
            isFilter,
            label,
            required,
            noDeletion,
            redstar,
            highLight,
            islock,
            filtered,
            visible,
            ishighlight,
            isbold,
            virtually,
        } = this.props;
        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        return <li className="field-item">
            <div
                className={classnames({
                    'field-item-filtered': filtered,
                    'field-item-content': true,
                    'show-highlight': isbold,
                })}
            >
                {required && <span className="unselected-mark iconfont icon-xinghao"></span>}
                <span className="field-label" title={label}>{label}</span>
                {!virtually && !uncontrolledVisible && <span className="field-icon" onClick={this.onTransferToView}>
                    <Tooltip
                        placement="top"
                        overlay={langJson['action-icon-add']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('ncc-sq', 'close')} />
                    </Tooltip>
                </span>}
                {/* {!virtually && <span className="field-icon icon-highlight" onClick={this.onHighlight}>
                    <Tooltip
                        placement="top"
                        overlay={langJson['action-icon-light']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('tgaoliang', isbold ? 'activated' : 'close')} />
                    </Tooltip>
                </span>} */}
            </div>
        </li>;
    }
}

export default Field;